import { fail } from "@sveltejs/kit";
import { p as prisma } from "../../../../../chunks/prisma.js";
const load = (async ({ url }) => {
  try {
    const categoryFilter = url.searchParams.get("category");
    const whereClause = categoryFilter && categoryFilter !== "all" ? {
      categories: {
        some: {
          id: parseInt(categoryFilter)
        }
      }
    } : {};
    const [products, categories] = await Promise.all([
      prisma.product.findMany({
        where: whereClause,
        select: {
          id: true,
          name: true,
          sortOrder: true,
          serviceCode: true,
          isPublished: true,
          Image: {
            select: {
              url: true
            },
            take: 1
          },
          categories: {
            select: {
              id: true,
              name: true
            }
          }
        },
        orderBy: { sortOrder: "asc" }
      }),
      prisma.category.findMany({
        select: {
          id: true,
          name: true
        },
        orderBy: { sortOrder: "asc" }
      })
    ]);
    return {
      products,
      categories,
      selectedCategory: categoryFilter || "all"
    };
  } catch (e) {
    console.error("Error getting products for sorting: ", e);
    return { status: 500, error: "Internal server error" };
  }
});
const actions = {
  updateSort: async ({ request, url }) => {
    try {
      const formData = await request.formData();
      const updates = JSON.parse(formData.get("updates"));
      const category = formData.get("category");
      const hasDecimals = updates.some((update) => update.sortOrder % 1 !== 0);
      if (hasDecimals) {
        const allProducts = await prisma.product.findMany({
          select: { id: true, sortOrder: true },
          orderBy: { sortOrder: "asc" }
        });
        const updateMap = new Map(updates.map((u) => [u.id, u.sortOrder]));
        const updatedProducts = allProducts.map((product) => ({
          ...product,
          sortOrder: updateMap.has(product.id) ? updateMap.get(product.id) : product.sortOrder
        })).sort((a, b) => Number(a.sortOrder) - Number(b.sortOrder));
        const normalizedUpdates = updatedProducts.map((product, index) => ({
          id: product.id,
          sortOrder: index + 1
        }));
        await prisma.$transaction(
          normalizedUpdates.map(
            (update) => prisma.product.update({
              where: { id: update.id },
              data: { sortOrder: update.sortOrder }
            })
          )
        );
      } else {
        await prisma.$transaction(
          updates.map(
            (update) => prisma.product.update({
              where: { id: update.id },
              data: { sortOrder: update.sortOrder }
            })
          )
        );
      }
      return { success: true, category };
    } catch (e) {
      console.error("Error updating sort order: ", e);
      return fail(500, { error: "Failed to update sort order" });
    }
  }
};
export {
  actions,
  load
};
